export enum FeeTypeEnum {
  OneTime= 'OneTime',
  Recurring= 'Recurring'
}
